// extracted by mini-css-extract-plugin
module.exports = {"global_hover_card":"GlobalHoverCard_global_hover_card__3Pubk"};